import { StateCreator } from "zustand";
import {
  ReplacementOptions,
  type ReplacementDropdownOptionType,
  ReplacementType,
} from "./videoBackgrounds.types";

// --- State Type ---
export type VideoBackgroundsSliceState = {
  backgroundReplacementOption: ReplacementOptions;
  imageBlob: Blob | undefined;
  isBackgroundLoading: boolean;
  cpuUtilization: string;
};

// --- Actions Type ---
export type VideoBackgroundsSliceActions = {
  setBackgroundReplacementOption: (option: ReplacementOptions) => void;
  setImageBlob: (blob: Blob | undefined) => void;
  setBackgroundLoading: (loading: boolean) => void;
  setCpuUtilization: (value: string) => void;
  resetBackgrounds: () => void;
};

// --- Combined Type ---
export type VideoBackgroundsSlice = VideoBackgroundsSliceState &
  VideoBackgroundsSliceActions;

// --- Constants ---
export const REPLACEMENT_OPTIONS_LIST: ReplacementDropdownOptionType[] = [
  {
    label: ReplacementOptions.Blue,
    type: ReplacementType.Color,
    value: "#0000ff",
  },
  {
    label: ReplacementOptions.Beach,
    type: ReplacementType.Image,
    value: ReplacementOptions.Beach,
  },
];

// --- Initial State ---
export const initialVideoBackgroundsState: VideoBackgroundsSliceState = {
  backgroundReplacementOption: ReplacementOptions.Blue,
  imageBlob: undefined,
  isBackgroundLoading: false,
  cpuUtilization: "40",
};

// --- Slice Creator ---
export const createVideoBackgroundsSlice: StateCreator<
  VideoBackgroundsSlice,
  [],
  [],
  VideoBackgroundsSlice
> = (set) => ({
  ...initialVideoBackgroundsState,

  setBackgroundReplacementOption: (option) =>
    set({ backgroundReplacementOption: option }),
  setImageBlob: (blob) => set({ imageBlob: blob }),
  setBackgroundLoading: (loading) => set({ isBackgroundLoading: loading }),
  setCpuUtilization: (value) => set({ cpuUtilization: value }),
  resetBackgrounds: () => set(initialVideoBackgroundsState),
});

// --- Selectors ---
export const videoBackgrounds = {
  all: (s: VideoBackgroundsSlice) => ({
    option: s.backgroundReplacementOption,
    imageBlob: s.imageBlob,
    isLoading: s.isBackgroundLoading,
    cpuUtilization: s.cpuUtilization,
    setOption: s.setBackgroundReplacementOption,
    setBlob: s.setImageBlob,
    setLoading: s.setBackgroundLoading,
    setCpuUtilization: s.setCpuUtilization,
  }),
};
